import React, { useState } from "react";
import { Button, Card, Typography } from "antd";
import { LockOutlined, LogoutOutlined } from "@ant-design/icons";
import { useBilling } from "../../context/BillingContext";
import { useNavigate } from "react-router-dom";
import Logo from "../../components/Logo";
import logout from "../../utils/logout";

const { Title, Text } = Typography;

export default function LockoutScreen() {
  const { outstandingInvoice, isLocked, refreshStatus } = useBilling();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  // Safety check: if user lands here but isn't locked, send them back
  React.useEffect(() => {
    if (!isLocked) {
      navigate("/dashboard");
    }
  }, [isLocked, navigate]);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-4">
      <div className="mb-8">
        <Logo className="h-16 w-auto" />
      </div>

      <Card className="max-w-md w-full shadow-lg text-center border-t-4 border-red-600">
        <div className="mb-4 text-red-600">
          <LockOutlined style={{ fontSize: "48px" }} />
        </div>

        <Title level={2} className="!mb-2">
          Service Suspended
        </Title>
        <Text type="secondary" className="block mb-6">
          Access to the dashboard has been restricted due to overdue server
          fees.
        </Text>

        {outstandingInvoice && (
          <div className="bg-red-50 p-4 rounded-md mb-6 text-left">
            <div className="flex justify-between mb-2">
              <span className="text-gray-600">Overdue Period:</span>
              <span className="font-semibold">
                {outstandingInvoice.daysOverdue} Days
              </span>
            </div>
            <div className="flex justify-between mb-2">
              <span className="text-gray-600">Invoice ID:</span>
              <span className="font-mono">{outstandingInvoice.id}</span>
            </div>
          </div>
        )}

        <div className="flex justify-center gap-4">
          <Button icon={<LogoutOutlined />} onClick={() => logout()}>
            Logout
          </Button>
        </div>
      </Card>

      <div className="mt-8 text-center text-gray-500 text-sm"></div>
    </div>
  );
}
